import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

// eslint-disable-next-line import/no-cycle
import Tabs from './index';

export const TabItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TabEL = styled.div`
  display: flex;
  justify-content: center;
`;

const calculateStyle = ({ tabType }) => {
  let style;
  switch (tabType) {
    case Tabs.TYPE.DRAFT:
      style = css`
        height: inherit;
        background-color: ${props => props.theme.colors.almostWhite};
        padding: ${pxToRem('4px')};
        border: solid ${pxToRem('1px')} ${props => props.theme.colors.blue.one};
        align-items: center;
        font-size: ${pxToRem('16px')};
        color: ${props => props.theme.colors.blue.one};

        ${TabItem} {
          :only-child {
            width: inherit;
          }
          position: relative;
          display: inline-block;
          cursor: pointer;
          white-space: nowrap;
          z-index: 1;
          padding: ${pxToRem('8px')} ${pxToRem('48px')};
          overflow-x: auto;
          transition: font-weight 0.4s ease-in-out;

          ::first-letter {
            text-transform: capitalize;
          }

          &.active {
            font-weight: 500;
            background-color: ${props => props.theme.colors.blue.five};
            border: solid ${pxToRem('2px')} rgba(70, 122, 251, 0.04);
            border-radius: ${pxToRem('36px')};
            > div > span {
              font-weight: 600;
            }
          }
        }
      `;
      break;
    case Tabs.TYPE.PRIMARY:
    default:
      style = css`
        ${TabItem} {
          flex-basis: 100%;
          :only-child {
            width: inherit;
          }
          position: relative;
          display: inline-block;
          cursor: pointer;
          padding: ${pxToRem('20px')};
          white-space: nowrap;
          z-index: 1;
          padding: ${pxToRem('20px')} ${pxToRem('70px')};
          overflow-x: auto;
          transition: font-weight 0.4s ease-in-out;

          ::first-letter {
            text-transform: capitalize;
          }

          &.active {
            color: ${props => props.theme.colors.black.one};
            font-weight: 500;
            background-color: ${props => props.theme.colors.blue.five};
            border: solid ${pxToRem('2px')} rgba(70, 122, 251, 0.04);
            border-radius: ${pxToRem('36px')};
            > div > span {
              font-weight: 600;
            }
          }
        }
      `;
      break;
  }

  return style;
};

export const TabsContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: flex-end;
  position: relative;
  overflow: scroll;
  justify-content: space-between;
  background-color: ${props => props.theme.colors.lighterWhite};
  border-radius: ${pxToRem('36px')};
  border: solid ${pxToRem('2px')} ${props => props.theme.colors.lightGray3};
  padding: ${pxToRem('10px')};
  align-content: center;

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }

  ${props => calculateStyle(props)};

  @media ${props => props.theme.device.laptop} {
    height: auto;
  }
`;
